import { findMatchingPartialCount } from 'src/app/project/modules/points/points-group-sizes/match-partial-count';
import { GET_TABLE } from '../../../table.ui.store';

export function getGroupSize(groupId: string): number | undefined {
  const item = GET_TABLE()?.items?.find((tableItem) => tableItem.id === groupId);

  if (!item?.groupBy) {
    return;
  }

  return findMatchingPartialCount(item.groupBy)?.count;
}
